import { AxiosInstance } from "axios";

export const getHomeGroups = (user: string, instance: AxiosInstance) => {
    let reqBody = {
        "username": user,
        "groupTypes": {
        "departmentGroups": ["Department"],
        "welcomeGroups": ["ApplicantPortalWelcome", "HiredUserWelcome", "ParentPortalStaffing"],
        "pbsAssistGroups": ["PbsAssist"],
        "analystCoordination" : ["CareCoordinationAnalystOnly"],
        "fullTeamCoordination": ["CareCoordinationFullTeam"]
      }
    }
    return instance.post(`get-user-group-rooms`, reqBody);
}
export const getEncryptedUsername = (username: string, instance: AxiosInstance) => {
    return instance.get(`get-encrypted-username?username=${username}`);
}
export const getTreatmentGroup = (username: string, clientId: number, instance: AxiosInstance) => {
    return instance.get(`get-treatment-group?authUser=${username}&clientId=${clientId}`);
}